import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import AppHeader from '../Common/AppHeader';
import NavMenu from './NavMenu';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import MapLegends from './siteMaps/MapLegends';
import MapDetails from './siteMaps/MapDetails';

export default function StormwaterLayout({ loggedInUser, selectedMenu, onNavigationClick, viewerDocumentData, closeViewer, basePath, navigationItems, children }) {
    const params = useParams()
    const [navMenuClicked, setNavMenuClicked] = useState(false);
    const [navMenuItemClicked, setNavMenuItemClicked] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [pdfPageWidth, setPdfPageWidth] = useState();
    const pdfDocOptions = useMemo(() => ({ cMapUrl: 'cmaps/', cMapPacked: true }), []);
    

    useEffect(() => handleAutoCloseViewer(viewerDocumentData, closeViewer), [viewerDocumentData, closeViewer]);
    useEffect(() => handleAddResizeEvent(), []);

    function handleAutoCloseViewer(viewerDocumentData, closeViewer) {
        if (viewerDocumentData !== undefined && !viewerDocumentData?.type.includes("image") && viewerDocumentData.type !== "application/pdf") {
            closeViewer();
        }
    }

    function handleAddResizeEvent() {
        function handleResize() {
            if (window.innerWidth <= 925) {
                setNavMenuClicked(false);
                setNavMenuItemClicked(false);
            }
        }

        let timeoutId = undefined;
        function handleResizePdfPages() {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                if (window.innerWidth <= 825) {
                    setPdfPageWidth(window.innerWidth);
                }
                else {
                    setPdfPageWidth(825);
                }
            }, 350);
        }

        handleResize();
        handleResizePdfPages();
        window.addEventListener('resize', handleResize);
        window.addEventListener('resize', handleResizePdfPages);
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('resize', handleResizePdfPages);
        };
    }

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    function handleHamburgerClick() {
        setNavMenuItemClicked(false);
        setNavMenuClicked(!navMenuClicked);
    }

    function handleNavigationClick(name) {
        onNavigationClick(name);
        setNavMenuItemClicked(true);
        setNavMenuClicked(false);
    }

    var showNav = params.accessToken64 === undefined;
    var navMenu = showNav && (
        <div className="navigation-menu-container">
            <NavMenu
                onNavigationClick={handleNavigationClick}
                selectedMenu={selectedMenu}
                basePath={basePath}
                navigationItems={navigationItems}
                onHamburgerClick={handleHamburgerClick}
            />
        </div>);

    let navMenuClickedClass = navMenuClicked ? " navMenuClicked" : "";
    let navMenuItemClickedClass = navMenuItemClicked ? " navMenuItemClicked" : "";
    let appContainer = (<div className={`main-pane-container${navMenuClickedClass}${navMenuItemClickedClass}`}>
        {navMenu}
        <div className="main-pane">
            <AppHeader appName="Stormwater" loggedInUser={loggedInUser} onHamburgerClick={handleHamburgerClick} />
            <div className="flex-auto py-2 px-2">
                {children}
            </div>
            <div className="h-7"></div>
        </div>
    </div>);

    let docViewerContainer;
    if (viewerDocumentData?.src) {

        let docViewer;
        if (viewerDocumentData.src) {
            if (viewerDocumentData.type.includes("image") && viewerDocumentData.download === false) {
                docViewer = (<div className="flexbox-flex justify-center">
                    <img alt="" style={{ width: "100%", height: "100%", objectFit: "contain" }} src={viewerDocumentData.src} />
                </div>);
            }
            else if (viewerDocumentData.type === "application/pdf" && viewerDocumentData.download === false) {
                let docViewerPages = Array.from(new Array(numPages), (el, index) => (<Page key={`page_${index + 1}`} pageNumber={index + 1} className="pb-2" width={pdfPageWidth} />));
                docViewer = (<object data={viewerDocumentData.src} type={viewerDocumentData.type} className="flex justify-center">
                    <div className="flex justify-center overflow-y-auto overflow-x-hidden">
                        <Document file={viewerDocumentData.src} onLoadSuccess={onDocumentLoadSuccess} options={pdfDocOptions}>
                            {docViewerPages}
                        </Document>
                    </div>
                </object>);
            }
            else {
                const link = document.createElement("a");
                link.href = viewerDocumentData.src;
                link.download = viewerDocumentData.filename;
                link.click();
                //closeViewer();
            }
        }

        let mapRevisions = viewerDocumentData.map && (<MapDetails map={viewerDocumentData.map} />);
        let mapLegends = viewerDocumentData.showMapLegends && (<MapLegends />);

        docViewerContainer = (<div className="docViewer">
            <header className="app-header flexbox-flex justify-between pl-5">
                <div className="appNameContainer flexbox-flex align-center">
                    <span className=""><b>DHI</b>StormWater</span>
                </div>
                <div className="app-header-button" onClick={() => closeViewer()}>
                    <span>Close</span>
                    <i className="dhicon-cancel-2" />
                </div>
            </header>
            {docViewer}
            {mapRevisions}
            {mapLegends}
        </div>);
    }

    return (<Fragment>{appContainer}{docViewerContainer}</Fragment>);
}